export var kiroboMulticallContracts = [
    { chainId: 1, address: '0x0ae3Ef19F87b5931aC8fBc3E01bbEca8DB185849' },
    { chainId: 10, address: '0x92B83232F2579D77BE181Dc2b167f9a542F2e0DE' },
    { chainId: 42161, address: '0xD8d95c30874DfBD9981272c5d0F0729BA523D475' },
    { chainId: 8453, address: '0xC7D810CEc1465C85345eD7C2B103E7E6109eBE47' },
    { chainId: 11155111, address: '0x64754348Aa0fb27Cce9c40214e240755bBBcb265' },
];
export var kiroboMulticallSimulateContracts = {
    '1': '0x0ae3Ef19F87b5931aC8fBc3E01bbEca8DB185849',
    '10': '0x92B83232F2579D77BE181Dc2b167f9a542F2e0DE',
    '42161': '0xD8d95c30874DfBD9981272c5d0F0729BA523D475',
    '8453': '0xC7D810CEc1465C85345eD7C2B103E7E6109eBE47',
    '11155111': '0x64754348Aa0fb27Cce9c40214e240755bBBcb265',
};
export var kiroboMulticallContractsMap = {
    '1': '0x0ae3Ef19F87b5931aC8fBc3E01bbEca8DB185849',
    '10': '0x92B83232F2579D77BE181Dc2b167f9a542F2e0DE',
    '42161': '0xD8d95c30874DfBD9981272c5d0F0729BA523D475',
    '8453': '0xC7D810CEc1465C85345eD7C2B103E7E6109eBE47',
    '11155111': '0x64754348Aa0fb27Cce9c40214e240755bBBcb265',
};
